import {Dispatch} from 'react'
import {FACTURACION_TYPES} from '../../constants/facturacion.types'
import {ClienteF, FacturacionAction} from '../../interfaces/facturacion.interface'
import * as validacionesRegex from '../../utils/strings.utils'
import * as validators from '../../utils/validaciones'
import * as reg from '../../constants/Regex'
import {
  getActividadesEconomicas,
  getDepartamentos,
  getMunicipios,
  getTiposDocumento,
  setMunicipios,
} from '../catalogos.actions'
import {generalShowLoader} from '../general.actions'
import {State} from '../../reducers'
import {facturacionInitialState} from '../../initital-state/facturacion.state'
import {facturacionGetDatosEmisor} from './facturacionEmision.actions'

// ******************************************************************************************

export const facturacionFormClienteHandleChange = (formCliente: ClienteF) => ({
  type: FACTURACION_TYPES.FORMCLIENTE_HANDLE_CHANGE,
  payload: formCliente,
})
export const facturacionFormClienteAddError = (formError: ClienteF) => ({
  type: FACTURACION_TYPES.FORMCLIENTE_SET_ERRORS,
  payload: formError,
})
export const facturacionOpenModalCliente = () => ({
  type: FACTURACION_TYPES.MODAL_INFOCLIENTE_OPEN,
  payload: true,
})
export const facturacionCloseModalCliente = () => ({
  type: FACTURACION_TYPES.MODAL_INFOCLIENTE_CLOSE,
  payload: false,
})
export const facturacionInfoCliente = (info: any) => ({
  type: FACTURACION_TYPES.MODAL_SET_INFOCLIENTE,
  payload: info,
})


// ******************************************************************************************
// ? FUNCIONES O PROCEDIMIENTOS SIN PETICIONES RES
// ******************************************************************************************
export const facturacionFormClienteHandleChangeInputPhone =
  (phone: string) => async (dispatch: Dispatch<FacturacionAction>, getState: () => State) => {
    dispatch(facturacionFormClienteHandleChange({telefono: phone}))
  }
export const facturacionFormClienteHandleChangeActividad =
  (value: string, text: string) =>
  async (dispatch: Dispatch<FacturacionAction>, getState: () => State) => {
    dispatch(facturacionFormClienteHandleChange({actividad: value}))
  }
export const facturacionFormClienteHandleChangeInput =
  (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement> | any) =>
  async (dispatch: Dispatch<FacturacionAction>, getState: () => State) => {
    const {tipoDocumento} = getState().facturacion.formCliente
    let {name, value} = e.target
    switch (name) {
      case 'fecha':
        break
      case 'tipoDocumento':
        const tipoDoc = getState().catalogos.tipoDocumento.find((doc) => value === doc.codigo)
        dispatch(facturacionFormClienteHandleChange({numId: ''}))
        dispatch(facturacionFormClienteAddError({numId: ''}))
        if (tipoDoc)
          dispatch(facturacionFormClienteHandleChange({nombreTipoDocumento: tipoDoc.valor}))
        else {
          dispatch(facturacionFormClienteHandleChange({nombreTipoDocumento: ''}))
        }
        dispatch(
          facturacionFormClienteAddError({
            fecha: '',
            tipoDocumento: '',
            numId: '',
            nombre: '',
            departamento: '',
            municipio: '',
            direccion: '',
            email: '',
            telefono: '',
            actividad: '',
            nrc: '',
            descripcion: '',
          })
        )
        break
      case 'numId':
        if((tipoDocumento === "36" || tipoDocumento === "13") && !validacionesRegex.validarRegexNumericoInt(value) ) return
        if (!validacionesRegex.validarRegexNumIdentificacion(value)) return
        break
      case 'nombre':
        if (!validacionesRegex.validarRegexNombresCliente(value)) return
        break
      case 'departamento':
        const depto = getState().catalogos.departamentos.find((doc) => value === doc.codigo)
        if (depto) dispatch(facturacionFormClienteHandleChange({nombreDepartamento: depto.valor}))
        else dispatch(facturacionFormClienteHandleChange({nombreDepartamento: ''}))
        dispatch(facturacionFormClienteHandleChange({municipio: '', direccion: ''}))
        dispatch(facturacionFormClienteAddError({municipio: '', direccion: ''}))
        break
      case 'municipio':
        dispatch(facturacionFormClienteHandleChange({direccion: ''}))
        dispatch(facturacionFormClienteAddError({direccion: ''}))
        break
      case 'direccion':
        if (!validacionesRegex.validarRegexLetras(value)) return
        break
      case 'email':
        if (!validacionesRegex.validarRegexLetras(value)) return
        break
      case 'telefono':
        if (!validacionesRegex.validarRegexLetras(value)) return
        break
      case 'actividad':
        let actividad = getState().catalogos.actividadesEconomicas.find(
          (act) => act.codigo === value
        )
        dispatch(
          facturacionFormClienteHandleChange({descripcion: actividad ? actividad.valor : ''})
        )
        break
      case 'nrc':
        if (!validacionesRegex.validarRegexNumericoInt(value)) return
        break
      case 'descripcion':
        if (!validacionesRegex.validarRegexLetras(value)) return
        break
      default:
        break
    }

    dispatch(facturacionFormClienteHandleChange({[name]: value}))
  }

// ******************************************************************************************
// ? PETICIONES RES
// ******************************************************************************************
export const facturacionConsultarCatalogos = () => async (dispatch: Dispatch<any>) => {
  try {
    Promise.all([
      dispatch(getDepartamentos()),
      dispatch(getTiposDocumento()),
      dispatch(getActividadesEconomicas()),
      dispatch(facturacionGetDatosEmisor()),
    ])
  } catch (error) {}
}

// ******************************************************************************************
// ? VALIDACIONES
// ******************************************************************************************
export const facturacionFormClienteOnBlurPhone =
  (phone: string) => async (dispatch: Dispatch<any>, getState: () => State) => {
    const {tipoDocumento} = getState().facturacion.formCliente
    let message = ''
    message = validators.validacionEsRequerido(phone, message, 'Teléfono celular')
    if (!message) message = validators.validacionMinLenght(phone, message, 8)
    if (!message)
      message = validators.validacionRegex(reg.REGEX_TELEFONO, phone, message, 'Teléfono celular')
    dispatch(facturacionFormClienteAddError({telefono: phone}))
  }

export const facturacionFormClienteOnBlurActividad =
  (value: string) => async (dispatch: Dispatch<any>, getState: () => State) => {
    const {tipoDocumento} = getState().facturacion.formCliente
    let message = ''
    message = validators.validacionEsRequerido(value, message, 'Actividad', 'requerida')
    if (!message) message = validators.validacionMinLenght(value, message, 2)
    if (!message)
      message = validators.validacionRegex(reg.REGEX_CODE_ACTIVIDAD, value, message, 'actividad')
    let actividad = getState().catalogos.actividadesEconomicas.find((act) => act.codigo === value)
    dispatch(facturacionFormClienteHandleChange({descripcion: actividad ? actividad.valor : ''}))
  }

export const facturacionFormClienteOnBlur =
  (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement> | any) =>
  async (dispatch: Dispatch<any>, getState: () => State) => {
    let {name, value} = e.target
    const {tipoDocumento, telefono, checkContribuyente, checkCF, checkExentoImpuesto, chipsEmail} = getState().facturacion.formCliente
    const idDoc = getState().documentos.activeDoc?.idDoc

    if (tipoDocumento === '-1') return

    let message = ''
    switch (name) {
      case 'fecha':
        message = validators.validacionEsRequerido(value, message, 'Fecha')
        break
      case 'tipoDocumento':
        message = validators.validacionEsRequerido(
          value,
          message,
          'Tipo de documento de identificación'
        )
        if (!value) {
          dispatch(
            facturacionFormClienteHandleChange({
              ...facturacionInitialState.formCliente,
              checkCF: getState().facturacion.formCliente.checkCF,
            })
          )
        }
        break
      case 'numId':
        if (tipoDocumento) {
          message = validators.validacionEsRequerido(
            value,
            message,
            getState().facturacion.formCliente.nombreTipoDocumento
          )
          if (!message) message = validators.validacionMinLenght(value, message, 3)
          if (!message)
            message = validators.validarTipoDocumento(
              getState().facturacion.formCliente.nombreTipoDocumento!,
              value,
              message
            )
        }
        break
      case 'nombre':
        const esFacturacionCF = idDoc === '01';
        const esNombreRequerido = tipoDocumento !== 'sinDocumento' && !checkContribuyente && !checkCF && !checkExentoImpuesto;

        if (tipoDocumento || checkCF || checkExentoImpuesto) {
          if (esFacturacionCF && !value && esNombreRequerido) {
            message = '';
          } else {
            message = validators.validacionEsRequerido(value, message, 'Nombre');
          }
        }
        break
      case 'departamento':
        if (tipoDocumento) {
          //message = validators.validacionEsRequerido(value, message, 'Departamento')
        }

        // Obtener el catálogo de municipio
        const depto = getState().facturacion.formCliente.nombreDepartamento
        if (depto) await dispatch(getMunicipios(Number(value), depto, true))
        else dispatch(setMunicipios([]))
        dispatch(
          facturacionFormClienteHandleChange({
            municipio: '',
            nombreMunicipio: '',
          })
        )
        break
      case 'municipio':
        if (tipoDocumento) {
          //message = validators.validacionEsRequerido(value, message, 'Municipio')
        }
        break
      case 'direccion':
        if (tipoDocumento) {
          //message = validators.validacionEsRequerido(value, message, 'Dirección')
          //if (!message) message = validators.validacionMinLenght(value, message, 5)
        }
        break
      case 'email':
        if (tipoDocumento) {
          if (idDoc !== '01' || value) {
            if (!chipsEmail?.length) {
              message = validators.validacionEsRequerido(value, message, 'Correo electrónico')
            }
            if (!message && value) message = validators.validacionEmail(value, message, 'Correo electrónico')
          }
        }
        break
      case 'telefono':
        if (tipoDocumento) {
          if (idDoc !== '01' || telefono || checkContribuyente === true) {
            message = validators.validacionEsRequerido(value, message, 'Teléfono celular')
            if (!message) message = validators.validacionMinLenght(value, message, 8)
            if (!message)
              message = validators.validacionRegex(
                reg.REGEX_TELEFONO,
                value,
                message,
                'Teléfono celular'
              )
          }
        }
        break
      case 'actividad':
        if (tipoDocumento) {
          if (idDoc !== '01' || value || checkContribuyente === true) {
            message = validators.validacionEsRequerido(value, message, 'Actividad', 'requerida')
            if (!message) message = validators.validacionMinLenght(value, message, 2)
            if (!message)
              message = validators.validacionRegex(
                reg.REGEX_CODE_ACTIVIDAD,
                value,
                message,
                'actividad'
              )
            let actividad = getState().catalogos.actividadesEconomicas.find(
              (act) => act.codigo === value
            )
            dispatch(
              facturacionFormClienteHandleChange({descripcion: actividad ? actividad.valor : ''})
            )
          }
        }

        break
      case 'nrc':
        if (tipoDocumento) {
          if(value) {
            // message = validators.validacionEsRequerido(value, message, 'NRC')
            if (!message) message = validators.validacionMinLenght(value, message, 2)
            if (!message) message = validators.validacionRegex(reg.REGEX_NRC, value, message, 'NRC')
          }
        }
        break
      case 'descripcion':
        message = validators.validacionEsRequerido(value, message, 'Descripción', 'requerida')
        if (!message) message = validators.validacionMinLenght(value, message, 5)
        break
      default:
        break
    }
    dispatch(facturacionFormClienteAddError({[name]: message}))
  }

export const facturacionFormClienteValidacionesGenerarFactura = (
  dispatch: Dispatch<FacturacionAction>,
  getState: () => State
) => {
  const {formCliente, errorsFormCliente} = getState().facturacion
  const {activeDoc} = getState().documentos
  const idDoc = getState().documentos.activeDoc?.idDoc

  if (formCliente.tipoDocumento === '-1') return false

  if (
    formCliente.tipoDocumento ||
    activeDoc.idDoc !== '01' ||
    (formCliente.checkCF === false && activeDoc.idDoc === '01')
  ) {
    if (formCliente.checkCF === false) {
      errorsFormCliente.tipoDocumento = validators.validacionEsRequerido(
        formCliente.tipoDocumento!,
        '',
        'Tipo de documento de identificación'
      )
    }

    if (
      idDoc === '01' &&
      !formCliente.numId &&
      formCliente.tipoDocumento === "sinDocumento"
    ) {
      errorsFormCliente.numId = ''
    } else {
      errorsFormCliente.numId = validators.validacionEsRequerido(
        formCliente.numId!,
        errorsFormCliente.numId!,
        getState().facturacion.formCliente.nombreTipoDocumento
      )
      if (!errorsFormCliente.numId)
        errorsFormCliente.numId = validators.validacionMinLenght(
          formCliente.numId!,
          errorsFormCliente.numId,
          3
        )
      if (!errorsFormCliente.numId)
        errorsFormCliente.numId = validators.validarTipoDocumento(
          getState().facturacion.formCliente.nombreTipoDocumento!,
          formCliente.numId!,
          errorsFormCliente.numId
        )
    }


    // Nombre -------------------------------
    const esFacturacionCF = idDoc === '01';
    const esNombreRequerido = formCliente.tipoDocumento !== 'sinDocumento' && !formCliente.nombre && !formCliente.checkContribuyente && !formCliente.checkCF && !formCliente.checkExentoImpuesto;
    if (esFacturacionCF && esNombreRequerido) {
      errorsFormCliente.nombre = ''
    } else {
      errorsFormCliente.nombre = validators.validacionEsRequerido(
        formCliente.nombre!,
        errorsFormCliente.nombre!,
        'Nombre'
      )
    }

    // Comentado - Los departamentos, municio y direccion no son requeridos
    if (formCliente.checkContribuyente) {
      errorsFormCliente.departamento = validators.validacionEsRequerido(
        formCliente.departamento!,
        errorsFormCliente.departamento!,
        'Departamento'
      )
  
      errorsFormCliente.municipio = validators.validacionEsRequerido(
        formCliente.municipio!,
        errorsFormCliente.municipio!,
        'Municipio'
      )
  
      errorsFormCliente.direccion = validators.validacionEsRequerido(
        formCliente.direccion!,
        errorsFormCliente.direccion!,
        'Dirección'
      )
      if (!errorsFormCliente.direccion)
        errorsFormCliente.direccion = validators.validacionMinLenght(
          formCliente.direccion!,
          errorsFormCliente.direccion!,
          5
      )
    }
    
    if (idDoc !== '01' || formCliente.email) {
      if (!formCliente.chipsEmail?.length) {
        errorsFormCliente.email = validators.validacionEsRequerido(
          formCliente.email!,
          errorsFormCliente.email!,
          'Correo electrónico'
        )
      }
      
      if (!errorsFormCliente.email && formCliente.email) {
        errorsFormCliente.email = validators.validacionEmail(
          formCliente.email!,
          errorsFormCliente.email!,
          'Correo electrónico'
        )
      }
    }

    if (idDoc !== '01' || formCliente.telefono || formCliente.checkContribuyente === true) {
      errorsFormCliente.telefono = validators.validacionEsRequerido(
        formCliente.telefono!,
        errorsFormCliente.telefono!,
        'Teléfono celular'
      )
      if (!errorsFormCliente.telefono)
        errorsFormCliente.telefono = validators.validacionMinLenght(
          formCliente.telefono!,
          errorsFormCliente.telefono!,
          8
        )
      if (!errorsFormCliente.telefono)
        errorsFormCliente.telefono = validators.validacionRegex(
          reg.REGEX_TELEFONO,
          formCliente.telefono!,
          errorsFormCliente.telefono!,
          'Teléfono celular'
        )
    }

    // if (idDoc !== '01' || formCliente.actividad || formCliente.checkContribuyente === true) {
    //   errorsFormCliente.actividad = validators.validacionEsRequerido(
    //     formCliente.actividad!,
    //     errorsFormCliente.actividad!,
    //     'Actividad',
    //     'requerida'
    //   )
    //   if (!errorsFormCliente.actividad)
    //     errorsFormCliente.actividad = validators.validacionMinLenght(
    //       formCliente.actividad!,
    //       errorsFormCliente.actividad!,
    //       2
    //     )
    //   if (!errorsFormCliente.actividad)
    //     errorsFormCliente.actividad = validators.validacionRegex(
    //       reg.REGEX_CODE_ACTIVIDAD,
    //       formCliente.actividad!,
    //       errorsFormCliente.actividad!,
    //       'actividad'
    //     )
    // }

    // if (formCliente.nrc || formCliente.checkContribuyente === true) {
    //   errorsFormCliente.nrc = validators.validacionEsRequerido(formCliente.nrc!, errorsFormCliente.nrc!, 'NRC')
    //   if (!errorsFormCliente.nrc) errorsFormCliente.nrc = validators.validacionMinLenght(formCliente.nrc!, errorsFormCliente.nrc!, 2)
    //   if (!errorsFormCliente.nrc) errorsFormCliente.nrc = validators.validacionRegex(reg.REGEX_NRC, formCliente.nrc!, errorsFormCliente.nrc!, 'nrc')      
    // }
  }
  else if (formCliente.checkCF) {
    errorsFormCliente.nombre = validators.validacionEsRequerido(
      formCliente.nombre!,
      errorsFormCliente.nombre!,
      'Nombre'
    )
  }

  dispatch(facturacionFormClienteAddError(errorsFormCliente))
  if ( errorsFormCliente.actividad || errorsFormCliente.departamento || errorsFormCliente.direccion || errorsFormCliente.email || errorsFormCliente.fecha || errorsFormCliente.municipio || errorsFormCliente.nombre || errorsFormCliente.nrc || errorsFormCliente.numId || errorsFormCliente.telefono)
    return true
  return false
}
